import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';
import { getUrls } from '@/utils/getUrls';

const { BASE_URL } = getUrls();

// [管理员]查询管理员列表
export async function getAdminList(params) {
  const url = `/admin/list${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}
// [管理员]管理员查询来访者聊天记录的咨询师列表
export async function adminGetConsultantByStaff(params) {
  const url = `/admin/getConsultantListByStaff${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// admin service api
// 管理员登录
export async function loginByAdmin(data) {
  const url = `/admin/login`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// [管理员]查询待审核列表
export async function getInfoApply(params) {
  const url = `/admin/infoApply/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员]拒绝咨询师资料申请
export async function refuseInfoApply(params) {
  const url = '/admin/infoApply/refuse';
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [管理员]同意咨询师资料申请
export async function agreeInfoApply(params) {
  const url = '/admin/infoApply/pass';
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [管理员]通过authId查询咨询师基本信息
export async function getConsultantInfo(authId) {
  const url = `/admin/consultant/info${_getQuerystr(authId)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员]查询咨询师列表
export async function getConsultantList(params) {
  const url = `/admin/consultant/list${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员] 查询咨询师工作日历（排班+预约）
export async function getConsultantScheduling(params) {
  const url = `/admin/consultantScheduling${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员] 查询咨询记录
export async function getConsultant(params) {
  const url = `/admin/consult${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员] 分页查询咨询记录
export async function getConsultantByTime(params) {
  const url = `/admin/consult/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员] 按照来访者分组查询咨询记录
export async function getConsultantByGroup(params) {
  const url = `/admin/consult/groupList${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [管理员] 分页查询咨询评价
export async function adminGetEvaluationList(params) {
  const url = `/admin/consult/pageEvaluation${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 查询咨询师的咨询评价总分
export async function adminGetEvaluationConsultantTotalScore(consultantId) {
  const url = `/admin/evaluation/consultantTotalScore${_getQuerystr(consultantId)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员]搜索咨询师（姓名or昵称or手机号）
export async function adminSearchConsultant(searchKeyword) {
  const url = `/admin/searchConsultant${_getQuerystr(searchKeyword)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 清除未读消息
export async function adminClearChat(params) {
  const url = `/admin/chat/clear`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [管理员] 查询聊天记录
export async function adminGetChatMsg(params) {
  const url = `/admin/chat/msgPage${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 聊天文件上传
export async function adminUpload(resourceType, params) {
  const url = `/admin/upload/${resourceType}`;
  return await _request({
    method: 'POST',
    url,
    data: params,
    type: 'upload'
  })
}

// [管理员]查询咨询师的咨询评价总得分
export async function adminGetRecord(params) {
  const url = `/admin/consult/pageRecode${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 咨询完成确认
export async function adminConsultRecodeCompleted(params) {
  const url = `/admin/consult/consultRecodeCompleted`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

/**
 *  管理员分页查询咨询记录列表
 * @param {*} params 
 * @returns 
 */
export async function getAdminConsultationRecord(params) {
  const url = `/admin/consultationRecord/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 查看最近10次排班计划 
export async function adminGetLastTenTriggers(params) {
  const url = `/callcenter/getLastTenTriggers${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 上传排班表
export async function adminUploadScheduling(params) {
  const url = `/callcenter/schedule/upload`;
  return await _request({
    method: 'POST',
    url,
    data: params,
    type: 'upload'
  })
}

// [管理员] 查询排班咨询师列表
export async function adminGetAllExterns() {
  const url = `/callcenter/getAllExterns`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [管理员] 修改排班咨询师信息
export async function adminUpdateExtern(params) {
  const url = `/callcenter/updateMobile${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 管理员查询来访者信息
export async function adminSearchAuth(params) {
  const url = `/admin/searchAuth${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 七陌查询用户列表
/**
 * 
 * @param {*} params 
  ringingDateFrom 查询被叫振铃开始时间from
  ringingDateTo 查询被叫振铃开始时间to
  callNo 主叫号码
  calledNo 被叫号码
 * @returns 
 */
  export async function getCallcenterList(params) {
    const url = `/callcenter/page${_getQuerystr(params)}`;
    return await _request({
      method: 'GET',
      url,
    })
  }

  /**
 *  管理员查询记录详情
 * @param {*} params  recordId
 * @returns 
 */
export async function getAdminConsultationRecordDetail(params) {
  const url = `/admin/consultationRecord/${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}
/**
 *  管理员下载记录列表
 * @param {*} params
 * @returns 
 */
export async function downloadConsultationRecord(params) {
  const url = `${BASE_URL}admin/downloadConsultationRecord${_getQuerystr(params)}`;
  // return await _request({
  //   method: 'GET',
  //   url,
  // })
  return url;
}

// [新增咨询师，管理员] 关闭工单
// staffAuthId 来访者authId
// orderType 工单类型：1-文字咨询 2-AI咨询 3-向导
export async function closeWorkOrder(params) {
  const url = '/workOrder/close';
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

